import {Progress} from '@chakra-ui/react';

export default function ChakraProgress({...props}) {
    return <Progress {...props} />;
}
